import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { UnitOfMeasure } from 'src/app/core/models/unit-of-measure';
import { UnitOfMeasureService } from 'src/app/core/services/general/unit-of-measure.service';

@Component({
  selector: 'app-unit-of-measure-input',
  templateUrl: './unit-of-measure-input.component.html',
  styleUrls: ['./unit-of-measure-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: UnitOfMeasureInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: UnitOfMeasureInputComponent,
    },
  ],
})
export class UnitOfMeasureInputComponent {
  @Input()
  title = "Select Unit of Measure...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public unitOfMeasuresList: Array<CustomSelectOption> = [];

  constructor(
    private unitOfMeasureService: UnitOfMeasureService,
  ) {
    this.unitOfMeasureService
      .all()
      .subscribe((res: Array<UnitOfMeasure>) => {
        this.unitOfMeasuresList = res.map((el) => {
          return {
            name: `${el.name} - ${el.symbol}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.unitOfMeasuresList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
